<template>
  <div :class="$style.overlay">
    <img :src="loader" :class="$style.loader" />
    <p :class="$style.message">Searching...</p>
  </div>
</template>

<script>
import loader from '@/assets/img/progress-circle-success.svg'

export default {
  data () {
    return {
      loader
    }
  }
}
</script>

<style module lang="less" src="./SearchingComponent.less"></style>



// WEBPACK FOOTER //
// SearchingComponent.vue?680ae534